export default __webpack_public_path__ + "static/media/050-antenna.3eb2b382.png";